module.exports = __webpack_public_path__ + "static/img/Jason-Saab.c6f5bec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jason-Saab.jpg
// module id = XKw1
// module chunks = 0